<h2 mat-dialog-title *ngIf="action=='add'">Add Feeder</h2>
<h2 mat-dialog-title *ngIf="action=='update'">Update Feeder</h2>

<mat-tab-group>
    <mat-tab label="Description">
        <div>
            <form [formGroup]="descriptionForm">
                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Solar Make By</mat-label>
                        <input matInput formControlName="make_by" required>
                    </mat-form-field>
                    <span class="error"
                    *ngIf="descriptionForm.controls.make_by.touched && descriptionForm.controls.make_by.errors?.required">
                        Please Enter Solar Make By
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Serial Number</mat-label>
                        <input matInput formControlName="serialNo" required>
                    </mat-form-field>
                    <span class="error"
                    *ngIf="descriptionForm.controls.serialNo.errors?.required">
                        Please Enter Serial Number
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field>
                        <mat-label>Asset Name</mat-label>
                        <input matInput formControlName="asset_name" required>
                    </mat-form-field>
                    <span class="error"
                    *ngIf="descriptionForm.controls.asset_name.errors?.required">
                        Please Enter Serial Number
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>Manufacturing Date</mat-label>
                        <input type="datetime" matInput [matDatepicker]="picker" formControlName="manufacturing_date" >
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                    *ngIf=" descriptionForm.controls.manufacturing_date.errors?.required">
                        Please Enter Manufacturing Date
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field type="datetime"  >
                        <mat-label>Installation Date</mat-label>
                        <input matInput [matDatepicker]="picker1" formControlName="installation_date" >
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>

                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.installation_date.errors?.required">
                        Please Enter Installation Date
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>capacityKW</mat-label>
                        <input matInput formControlName="capacity_kw" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.capacity_kw.touched && descriptionForm.controls.capacity_kw.errors?.required">
                        Please Enter capacityKW
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>Panel Type</mat-label>
                        <input matInput formControlName="panel_type" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.panel_type.touched && descriptionForm.controls.panel_type.errors?.required">
                        Please Enter panelType
                    </span>
                </div>

                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>facing Direction</mat-label>
                        <input matInput formControlName="facing_direction" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.facing_direction.touched && descriptionForm.controls.facing_direction.errors?.required">
                        Please Enter facingDirection
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>tiltAngle</mat-label>
                        <input matInput formControlName="tilt_angle" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.tilt_angle.touched && descriptionForm.controls.tilt_angle.errors?.required">
                        Please Enter tiltAngle
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>inverterModel</mat-label>
                        <input matInput formControlName="inverter_model" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.inverter_model.touched && descriptionForm.controls.inverter_model.errors?.required">
                        Please Enter inverterModel
                    </span>
                </div>
                <div class="row col-md-12">
                    <mat-form-field  >
                        <mat-label>batteryStorageCapacity</mat-label>
                        <input matInput formControlName="battery_storage_capacity" required>
                    </mat-form-field>
                    <span class=" error"
                    *ngIf="descriptionForm.controls.battery_storage_capacity.touched && descriptionForm.controls.battery_storage_capacity.errors?.required">
                        Please Enter batteryStorageCapacity
                    </span>
                </div>
            </form>
        </div>
    </mat-tab>

    <mat-tab *ngIf="roleID == 1" label="Parameter">
        <div>
            <form [formGroup]="parameters">
                <mat-card class="example-card">
                    <mat-card-content>
                        <div class="scrollbar scrollbar-primary">
                            <div class="col-md-12" id="test">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>KWH</label>
                                    </div>
                                    <div class="col-md-3">
                                        <mat-slide-toggle  formControlName="kwh"></mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </form>
        </div>
    </mat-tab>

    <mat-tab label="Alert Parameters">
        <form [formGroup]="alertParameter">
            <h4>Alert Parameters</h4>
            <div class="row">
                <table>
                    <tr>
                        <td>
                            <mat-form-field class="form-element" style="margin-left: 15%;">
                                <mat-label>Frequency</mat-label>
                                <input type="number" matInput  formControlName = "kwhFrequency" >
                            </mat-form-field>
                            <span class="error"
                                *ngIf="frequencyMsg && frequencyMsg.kwhFrequency && frequencyMsg.kwhFrequency.length > 0">
                                {{frequencyMsg.kwhFrequency}}
                            </span>
                        </td>
                        <td>
                            <mat-label>Minutes</mat-label>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <mat-form-field style="margin-left: 15%;" >
                                <mat-label>Kwh </mat-label>
                                <input type="number" matInput formControlName="kwh">
                            </mat-form-field>
                            <span class=" error"
                            *ngIf="alertParameter.controls.kwh.touched && alertParameter.controls.kwh.errors?.required">
                                Please Enter KWH
                            </span>
                        </td>
                        <td>
                            <mat-label>Email</mat-label>
                            <mat-slide-toggle formControlName = "kwhEmail" ></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-label>SMS</mat-label>
                            <mat-slide-toggle formControlName = "kwhSMS"></mat-slide-toggle>
                        </td>
                        <td>
                            <mat-form-field class="form-element" hidden=true>
                                <mat-label>Time</mat-label>
                                <mat-select   formControlName="kwhTime" >
                                    <mat-option  *ngFor="let freq1 of Frequency" [value]="freq1">
                                        {{freq1}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </td>
                    </tr>

                    
                </table>
            </div>
        </form>
    </mat-tab>

    <mat-tab label="Alert Notification">
        <form [formGroup]="altertNotification"  class="form">
            <h4>Email for Alarms</h4>
            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Email 1</mat-label>
                    <input matInput formControlName="email1" required>
                </mat-form-field>
                <span class=" error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.required">
                    Please Enter Email 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.email1.touched && altertNotification.controls.email1.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 2</mat-label>
                    <input matInput formControlName="email2">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email2.touched && altertNotification.controls.email2.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 3</mat-label>
                    <input matInput formControlName="email3">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email3.touched && altertNotification.controls.email3.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 4</mat-label>
                    <input matInput formControlName="email4">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email4.touched && altertNotification.controls.email4.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>
            <div class="row col-md-12">

                <mat-form-field  >
                    <mat-label>Email 5</mat-label>
                    <input matInput formControlName="email5">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.email5.touched && altertNotification.controls.email5.errors?.email">
                    Please Enter Valid Email
                </span>
            </div>

            <h4>SMS For Alarms</h4>

            <div class="row col-md-12">

                <mat-form-field>
                    <mat-label>Phone Number 1</mat-label>
                    <input matInput formControlName="phoneNo1" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.required">
                    Please Enter Phone Number 1
                </span>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo1.touched && altertNotification.controls.phoneNo1.errors?.pattern">
                    Please Enter Valid Phone Number 1
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 2</mat-label>
                    <input matInput formControlName="phoneNo2">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo2.touched && altertNotification.controls.phoneNo2.errors?.pattern">
                    Please Enter Valid Phone Number 2
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 3</mat-label>
                    <input matInput formControlName="phoneNo3">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo3.touched && altertNotification.controls.phoneNo3.errors?.pattern">
                    Please Enter Valid Phone Number 3
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 4</mat-label>
                    <input matInput formControlName="phoneNo4">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo4.touched && altertNotification.controls.phoneNo4.errors?.pattern">
                    Please Enter Valid Phone Number 4
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Phone Number 5</mat-label>
                    <input matInput formControlName="phoneNo5">
                </mat-form-field>
                <span class="error"
                    *ngIf="altertNotification.controls.phoneNo5.touched && altertNotification.controls.phoneNo5.errors?.pattern">
                    Please Enter Valid Phone Number 5
                </span>
            </div>

        </form>
    </mat-tab>

    <mat-tab *ngIf="roleID == 1" label="DTMU Device">
        <form [formGroup]="dtmuDevice" *ngIf="dtmuDevice" class="form">
            <h4>New Machine Details</h4>
            <div class="row col-md-12">
                <mat-form-field >
                    <mat-label>Device Category</mat-label>
                    <mat-select formControlName="device_category" required>
                        <mat-option  *ngFor="let category of deviceMaster.deviceCategory" [value]="category">
                             {{category}}
                        </mat-option>
                    </mat-select>
                 </mat-form-field>
                 <span class="error"
                 *ngIf="dtmuDevice.controls.device_category.touched && dtmuDevice.controls.device_category.errors?.required">
                Please Select Device Category
             </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Device Model</mat-label>
                    <mat-select  formControlName="device_model" required>
                        <mat-option *ngFor='let model of deviceMaster.deviceModel' [value]="model">
                            {{model}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
            </div>

            <div class="row col-md-12">
                <mat-form-field >
                    <mat-label>Device ID</mat-label>
                    <mat-select formControlName="device_id" required>
                        <mat-option *ngFor='let deviceId of deviceMaster.deviceId' [value]="deviceId">
                            {{deviceId}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>

            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Heart Beat</mat-label>
                    <input matInput formControlName="heart_beat" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.heart_beat.touched && dtmuDevice.controls.heart_beat.errors?.required">
                    Please Enter Heart Beat
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name" required>
                </mat-form-field>
                <span class="error"
                    *ngIf="dtmuDevice.controls.name.touched && dtmuDevice.controls.name.errors?.required">
                    Please Enter Name
                </span>
            </div>

            <div class="row col-md-12">
                <mat-form-field>
                    <mat-label>Passcode</mat-label>
                    <input matInput formControlName="passcode" required>
                </mat-form-field>
            </div>
       
            <div class="row col-md-12">
                <mat-label>Remote Controller</mat-label>
                <mat-slide-toggle formControlName = "remote_controller"></mat-slide-toggle>
            </div>
        </form>
    </mat-tab>
</mat-tab-group>

<mat-dialog-actions>
    <div class="form-element">
        <button mat-raised-button color="primary" type="submit" [disabled]="!descriptionForm.valid || !altertNotification.valid || !dtmuDevice.valid" (click)="onSubmit(descriptionForm.value, parameters.value, alertParameter.value, altertNotification.value, dtmuDevice.value)" class="button" >Save</button>
    </div>
    <button class="mat-raised-button" >Close</button>
</mat-dialog-actions>